import { render, staticRenderFns } from "./crumbs.vue?vue&type=template&id=3dc3bc07&"
import script from "./crumbs.vue?vue&type=script&lang=js&"
export * from "./crumbs.vue?vue&type=script&lang=js&"
import style0 from "./crumbs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports